import React from 'react';
import { useLocation } from 'react-router-dom';

import ReportGenerator from '../../common/ReportGenerator/ReportGenerator.module';


const SalesReport: React.FC = () => {
  const location = useLocation(); // Initialize useLocation
  const { selectedCoproId } = location.state || {}; // Extract coproId from state

  const getReportUrl = (companyId: string, coproId: string) => `/api/companies/${companyId}/copros/${coproId}/report/sales/generate`;

  return (
    <ReportGenerator
      description="Cette page vous permet de générer des rapports des ventes pour vos copropriétés. Ces rapports incluent toutes les ventes de la copropriété sélectionnée et des informations sur la copropriété."
      getReportUrl={getReportUrl}
      generatedPdfFileName="rapport_ventes"
      initialCoproId={selectedCoproId || null}
      hasSalesRadiusOption
    />
  );
};

export default SalesReport;
